module.exports = __webpack_public_path__ + "static/website-8380adcec5c67ec8d539e9f37cd8ab82.jpg";